<template>
  <div class="card card-shadow ml-2 mr-2 ml-md-0 mr-md-0" :class="color_by_provider">
    <div class="card-header">
      <div class="row">
        <div class="col-md h6">
          <b>{{ entityName }}</b>
        </div>

        <div class="col-md">
          <div class="description">
            {{ $t('table.headers.offer_begin_datetime') }}
          </div>
          <b>{{ unavailabilityDate.start_at | formatDateAtTimeList }}</b>
        </div>

        <div class="col-md">
          <div class="description">
            {{ $t('table.headers.offer_end_datetime') }}
          </div>
          <b>{{ unavailabilityDate.end_at | formatDateAtTimeList }}</b>
        </div>

        <div class="col">
          <div class="btn-toolbar flex-wrap justify-content-end" v-if="provider == 'personal'">
            <div class="btn-group">
              <button class="btn btn-icon" @click.prevent="editUnavailability()">
                <i class="fa fa-edit"></i>
              </button>
              <button class="btn btn-icon-dark" @click.prevent="deleteUnavailability()">
                <i class="fa fa-trash-o"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="offer" class="card-body">
      <div class="row">
        <div class="col-md mt-3 mb-3 mt-md-0 mb-md-0">
          <div class="description">{{ $t('table.headers.services') }} </div>
          <services-with-hub v-if="hub" :hub="hub" :servicesNames="replacedService" />
          <b v-else>{{ replacedService }}</b>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import ServicesWithHub from '@/components/hubs/ServicesWithHub'

export default {
  name: 'UnavailabilityTableRow',
  props: ['unavailabilityDate', 'date', 'showHub'],
  components: {
    ServicesWithHub
  },
  computed: {
    provider() {
      return this.unavailabilityDate.provider
    },
    offer() {
      return this.unavailabilityDate.offer
    },
    color_by_provider() {
      if (this.provider == "offer") {
        return "card-offer-border-color"
      } else if (this.provider == "personal") {
        return "card-personal-border-color"
      }
      return "card-imported-border-color"
    },
    entityName() {
      if (this.provider == 'TsPlanner') {
        return this.unavailabilityDate.entity_name
      } else if (this.provider == "offer" && this.offer) {
        return this.offer.entity.name
      }

      return this.$i18n.t('CandidatePlanning.unavailable')
    },
    hub() {
      if(this.offer &&
         this.offer.entity &&
         this.offer.entity.hubs &&
         this.offer.entity.hubs.filter((hub) => !hub.is_fake).length > 0 &&
         this.offer.hub &&
         this.offer.hub.name) {
        return { name: this.offer.hub.name };
      }

      return null;
    },
    replacedService() {
      return this.offer ? this.offer.replaced_service.name : ""
    },
    startAt() {
      return this.offer ? this.offer.start_at : this.unavailabilityDate.start_at
    },
    endAt() {
      return this.offer ? this.offer.end_at : this.unavailabilityDate.end_at
    },
  },
  methods: {
    ...mapActions({
      loadUnavailabilityDateScheduled: 'unavailabilityDates/loadUnavailabilityDateScheduled'
    }),
    editUnavailability() {
      this.$store.commit('unavailabilityDates/SET_UNAVAILABILITY_DATE', this.unavailabilityDate)
      $('#modal-date-form').modal('show');
    },
    deleteUnavailability() {
      let self = this
      this.$dialog.confirm(this.$t('messages.delete_confirmation', {'resource': 'vos indisponibilités'}))
      .then(function () {
        self.$store.dispatch('unavailabilityDates/delete', self.unavailabilityDate.id).then(() => {
          self.loadUnavailabilityDateScheduled({
            start_date: moment(self.date, 'YYYY/MM/DD').startOf('month').format(self.$i18n.t('format.date')),
            end_date: moment(self.date, 'YYYY/MM/DD').endOf('month').format(self.$i18n.t('format.date')),
          })
        })
      })
      .catch(function () {})
    },
  },
}
</script>

<style lang="scss" scoped>
  .planning-row{
    border-left: 10px solid #e51349;
  }

  .planning-row__name {
    text-transform: capitalize;
  }

  .imported-border-color {
    border-left: 10px solid #4e73df;
  }

  .offer-border-color {
    border-left: 10px solid #04be8c;
  }

  .personal-border-color {
    border-left: 10px solid #e51349;
  }
</style>



// WEBPACK FOOTER //
// src/components/unavailabilityCalendars/UnavailabilityTableRow.vue